export const typeOptions = [
  "display",
  "h1",
  "h2",
  "h3",
  "h4",
  "title",
  "subtitle",
  "body",
  "body-semi-bold",
  "body-bold",
  "link",
  "small",
  "small-bold",
  "footnote",
  "footnote-medium",
  "footnote-bold",
  "label",
  "custom",
];

export const props = Object.freeze({
  /**
   * Typography token name driving font, weight, size, and line-height. Picks one of the design-system typescale presets — display, h1–h4, title, subtitle, body (regular/semi-bold/bold), link, small, footnote (regular/medium/bold), label — or `custom` for the consumer-driven escape hatch fed by --sp-comp-text-custom-font-short.
   *
   * @type {String}
   * @default undefined
   * @storybook-control select
   */
  type: {
    type: String,
    default: undefined,
    validator: (value) => typeOptions.includes(value),
  },
  /**
   * Rendered HTML tag. Defaults to `<div>`. When the tag matches a typescale name (e.g. "h1") and no explicit `type` is set, the matching typescale is applied automatically.
   *
   * @type {String}
   * @default "div"
   */
  tag: {
    type: String,
    default: "div",
  },
  /**
   * Override the default text colour. Any valid CSS colour value.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
});
